// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.

export const highlightedAttrList = {
	FUEL_TYPE: 'normalFuelType',
	ESTIMATED_DELIVERY_DATE: 'estimatedDeliveryDate',
	LOCATION: 'accountName',
	ODOMETER: 'odometer',
	CERTIFIED: 'certified',
	CONDITION: 'type',
	OFFSITE: 'sharedVehicle',
	ONSITE: 'onSiteVehicle',
	CLASSIFICATION: 'classificationName'
};

export const inventoryPageSizes = {
	SM_PAGE_SIZE: 4,
	MD_PAGE_SIZE: 10,
	LG_PAGE_SIZE: 14,
	XL_PAGE_SIZE: 18
};

export const viewportWidthSizes = {
	SM_VIEWPORT_WIDTH_SIZE: 768,
	MD_VIEWPORT_WIDTH_SIZE: 1440,
	LG_VIEWPORT_WIDTH_SIZE: 1600
};

export const MIN_COLUMNS_FOR_POSITIONING = 2;
export const DEFAULT_MAX_COLUMNS_ON_SRP = 4;
export const MAX_NUM_HYUNDAI_ADS = 3;
export const MIN_NUM_HYUNDAI_ADS = 2;

export const PROMO_TYPES = {
	EVENT: 'EVENT',
	INCENTIVE: 'INCENTIVE',
	PARTS: 'PARTS',
	SERVICE: 'SERVICE',
	VEHICLE: 'VEHICLE'
};

export const CAROUSEL_TYPES = {
	IMAGE: 'image',
	MEDIA_FOCUSED: 'mediaFocused'
};

export const PHOTO_GALLERY_LIMIT = 6;

export const FOOTER_CTA_TYPES = {
	COMPARE: 'compare',
	TRACK: 'track',
	SAVE: 'save',
	DETAILS: 'details'
};

export const COMPARE_BUTTON_VARIANTS = {
	FOOTER: 'footer',
	OVER_IMAGE: 'over-image'
};

export const VIDEO_PROVIDERS = {
	DCPAIS: 'DCPAIS',
	CARFLIX: 'CARFLIX'
};

export const VEHICLE_STATUS_CONFIG = {
	in_transit: {
		tooltipLabelKey: 'VEHICLE_LOCATION_INTRANSIT',
		iconClass: 'ddc-icon-truck-filled',
		textLabelKey: 'IN_TRANSIT_TO_LOCATION',
		modalAriaLabelKey: 'IN_TRANSIT'
	},
	in_transit_at_factory: {
		tooltipLabelKey: 'VEHICLE_LOCATION_PRODUCTION',
		iconClass: 'ddc-icon-factory-filled',
		textLabelKey: 'IN_PRODUCTION_FOR_LOCATION',
		modalAriaLabelKey: 'IN_PRODUCTION'
	}
};
